import { createIcon } from '@chakra-ui/react';

export const History = createIcon({
  displayName: `History`,
  viewBox: `0 0 45.781 45.684`,
  path: (
    <g transform="translate(-968.291 446.056)">
      <line
        x2="10.104"
        transform="translate(991.602 -437.815)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="16.253"
        transform="translate(985.453 -432.921)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="16.253"
        transform="translate(985.453 -428.027)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="16.253"
        transform="translate(985.453 -423.133)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="16.253"
        transform="translate(985.453 -418.239)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="2.051"
        transform="translate(985.259 -437.815)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="10.104"
        transform="translate(989.322 -407.407)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="2.051"
        transform="translate(1003.718 -407.407)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M973.923-439.925c2.321,0,3.119,5.16-.879,5.16s-3.486-4.462-3.486-5.16.372-4.881,4.137-4.881,5.16,2.418,5.16,5.16v19.1l2.51,2.3-2.743,2.764v8.771s.372,5.081,4.6,5.081,4.648-3.44,4.648-5.532-1.039-4.369-3.31-4.369a2.4,2.4,0,0,0-2.644,2.645c0,1.027.082,2.561,2.1,2.561"
        transform="translate(0)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="5.66"
        transform="translate(973.044 -434.765)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M975.656-444.793h30c3.553,0,3.933,3.728,3.933,6.108h-2.03l-.063,2.2,1.713,1.333-2.626,2,3.007,1.928v18.725"
        transform="translate(-1.658 -0.004)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="23.581"
        transform="translate(984.354 -411.514)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="23.581"
        transform="translate(984.354 -401.622)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M1021.41-398.984c2.7,0,5.467,2.188,5.467,4.887a4.887,4.887,0,0,1-4.887,4.886"
        transform="translate(-14.056 -12.416)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </g>
  ),
});
